"use client";

import { FC } from "react";
import PageBanner from "./default";
import { VariantProps } from "./default";

const HaiAnhPageBanner: FC<VariantProps> = (props) => <PageBanner {...props} />;

HaiAnhPageBanner.displayName = "HaiAnhPageBanner";

export default HaiAnhPageBanner;
